module.exports = __webpack_public_path__ + "img/trophy.fce70424.svg";